exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preloader[data-v-11b7b546]{position:fixed;width:100%;height:100%;background:#040913}.preloader-content[data-v-11b7b546]{position:absolute;top:0;left:0;right:0;bottom:0;margin:auto;max-width:500px;width:100%;height:350px;text-align:center}.preloader-content h1[data-v-11b7b546]{color:#feea01;font-weight:800;font-size:40px;line-height:50px}.timer[data-v-11b7b546]{width:281px;margin:10px auto;border-radius:3px;height:5px;background:#494949;position:relative;overflow:hidden}.timer .fill[data-v-11b7b546]{position:absolute;top:0;left:0;width:100%;height:100%;background:#fff;transform-origin:left;animation:load-data-v-11b7b546 1 1s ease-in-out both}@keyframes load-data-v-11b7b546{0%{transform:scaleX(0)}to{transform:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11b7b546","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Preloader.vue
// module id = 47
// module chunks = 0